import React, { useState } from 'react';
import {
  Container,
  InnerContainer,
  NotificationsContainer,
  Subtitle,
  TitleContainer
} from './styles';
import Notifications from './Notifications';
import theme from '../../assets/styles/theme/theme';
import { Redirect, Route } from 'react-router-dom';
import { ERoutes } from '../../routes';
import useIsScreenSmallerThan from '../../hooks/useIsScreenSmallerThan';
import { Tab, Title } from '@gerdau/hefesto';
import { GetFlag } from '../../utils/featureFlag';
import { VerticalMenu } from '@gerdau/hefesto-mais-web';
import useSettings from './settings.hooks';
import { SettingsItem } from '../../components/SettingsItem';
import { NotificationOptionsEnum } from '../../components/SettingsItem/NotificationItem';

export enum ESettingsRoutes {
  NOTIFICATIONS = 'notifications'
}

const Settings: React.FC = () => {
  const DEFAULT_CHANNELS = ['gerdauMais', 'whatsapp', 'e-mail'];
  const isScreenSmallerThanTablet = useIsScreenSmallerThan(
    Number(theme.breakpoints.tablet.replace('px', ''))
  );
  const notificationsFlag = GetFlag('hub_notificacoes');
  const [activeKey, setActiveKey] = useState('notifications.orders');

  const { getMenuItem, defaultChannelOptions } = useSettings();

  const VerticalMenuItems = [
    getMenuItem('Notificações', 'notifications', undefined, [
      getMenuItem('Pedidos', 'notifications.orders'),
      getMenuItem('Finanças', 'notifications.finances')
    ])
  ];

  const onChangeItem = ({
    key,
    keyPath
  }: {
    key: string;
    keyPath: string[];
  }) => {
    if (keyPath.length >= 2) {
      setActiveKey(key);
    }
  };

  const onClickOption = (e: React.ChangeEvent<HTMLInputElement>) => {
    // * send event click to patch api that changes user preference and change user state
    // eslint-disable-next-line no-console
    console.log(e.target.value);
  };

  const getTabs = () => {
    return [
      {
        content: <Notifications />,
        key: ESettingsRoutes.NOTIFICATIONS,
        name: 'Notificações'
      }
    ];
  };

  return (
    <Container>
      <Route path={`${ERoutes.SETTINGS}/`} exact>
        <Redirect to={`${ERoutes.SETTINGS}/${ESettingsRoutes.NOTIFICATIONS}`} />
      </Route>

      <Route
        path={`${ERoutes.SETTINGS}/:settingsRoute?`}
        render={({ match, history }) =>
          notificationsFlag ? (
            <InnerContainer>
              <VerticalMenu
                items={VerticalMenuItems}
                defaultOpenKeys={['notifications']}
                defaultSelectedKeys={['notifications.orders']}
                onClick={({ key, keyPath }) => onChangeItem({ key, keyPath })}
              />
              <NotificationsContainer>
                {activeKey === 'notifications.orders' && (
                  <>
                    <Title level={2}>Notificações</Title>
                    <Subtitle>
                      Escolha os melhores canais para receber as suas
                      notificações.
                    </Subtitle>
                    <TitleContainer>
                      <Title level={3}>Pedidos - Aços Longos</Title>
                      <Title level={3}>Canais</Title>
                    </TitleContainer>
                    <SettingsItem
                      title="Pedido implantado"
                      channels={{
                        description:
                          'Os dados do seu pedido serão analisados, após todas as aprovações ele será confirmado.',
                        options: {
                          type: NotificationOptionsEnum.CHECKBOX,
                          content: defaultChannelOptions(
                            'longSteelOrders.orderdone',
                            DEFAULT_CHANNELS,
                            onClickOption
                          )
                        }
                      }}
                    />
                  </>
                )}
              </NotificationsContainer>
            </InnerContainer>
          ) : (
            <Tab
              onChange={(key: React.Key) =>
                history.push(`${ERoutes.SETTINGS}/${key}`)
              }
              tabItems={getTabs()}
              activeKey={match.params.settingsRoute as string}
              tabPosition={isScreenSmallerThanTablet ? 'top' : 'left'}
            />
          )
        }
      />
    </Container>
  );
};

export default Settings;
